<app-header></app-header>
<app-announcement></app-announcement>
<br>
<br>
<div class="userbtn_main">
  <div class="d-flex align-items-center gap-2">
    <button type="button" class="btn transaction_btn" (click)="GetTransaction()">
      Transactions
      <img src="/assets/images/transaction_icon.png">
    </button>
    <button type="button" (click)="DownloadRefundDetailReport();" class="btn transaction_btn">
      Download Report
      <img src="/assets/images/transaction_icon.png">
    </button>
  </div>
</div>
<div class="container-fluid blw_headermain">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 transaction_main" id="exTab1">
      <div class="refund_approve">Refund Approval / Rejection</div>
      <!-- Transacrion Tabs starts here -->
      <div>
        <div class="refundApprove" id="1a">
          <div class="searchmain">
            <input
              type="text"
              class="searchbox"
              pInputText
              size="50"
              style="width: 400px !important"
              placeholder=" Search Alphanumeric values here..."
              [(ngModel)]="globalSearchValue"
              (input)="dataTable.filterGlobal(globalSearchValue, 'contains')"
            >
            <i class="fa fa-search search_modified"></i>
          </div>
          <p-table #dataTable 
            [value]="refundApprove" 
            [globalFilterFields]="['orderID','invoiceID','orderInvoiceDate','transactionID','approvalCode','agency','agencyTcode','advertiser','submittedBy','amount','paymentTransType','cmComment']"
            [rows]="8" 
            [paginator]="true" 
            [pageLinks]="10" 
            [editable]="false"
            [reorderableColumns]="true" 
            columnResizeMode="fit" 
            [resizableColumns]="true" 
            (onRowSelect)="onRefundRowSelect($event)"
            (onRowUnselect)="onRowRefundUnselect($event)" 
            [(selection)]="selectedItems"
            [tableStyle]="{'table-layout':'auto','width':'100%','border-collapse': 'collapse'}"
            [responsiveLayout]="'scroll'">

            <ng-template pTemplate="header">
              <tr>
                <th style="width:38px;">
                  <i (click)="filterToggle($event)" class="fa fa-fw fa-filter cursorpointer"></i>
                </th>
                <th pSortableColumn="orderID">Order ID</th>
                <th pSortableColumn="invoiceID">Invoice ID</th>
                <th pSortableColumn="orderInvoiceDate">Invoice Date</th>
                <th pSortableColumn="transactionID">Transaction ID</th>
                <th pSortableColumn="approvalCode">Approval Code</th>
                <th pSortableColumn="agency">Agency</th>
                <th pSortableColumn="agencyTcode" *ngIf="!hideColums">Agency ID</th>
                <th pSortableColumn="advertiser">Advertiser</th>
                <th pSortableColumn="submittedBy">Submitted By</th>
                <th pSortableColumn="amount">Amount $</th>
                <th pSortableColumn="paymentTransType">Payment Transaction Type</th>
                <th pSortableColumn="cmComment">CM Comments</th>
                <th pSortableColumn="action" style="width: 199px;">Action</th>
                <th pSortableColumn="CreditManagerComments" style="width: 220px;">Comments</th>
                <th style="width:114px;"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData>
              <tr>
                <td>
                  <!-- <p-tableCheckbox [value]="rowData" [disabled]="rowData.invalidAction || rowData.invalidComments"></p-tableCheckbox> -->
                </td>
                <td>{{rowData.orderID}}</td>
                <td>{{rowData.invoiceID}}</td>
                <td>{{ rowData.orderInvoiceDate | date: 'MM/dd/yyyy' }}</td>
                <td>{{rowData.transactionID}}</td>
                <td>{{rowData.approvalCode}}</td>
                <td>{{rowData.agency}}</td>
                <td *ngIf="!hideColums">
                  <div *ngIf="rowData.agencyTcode != 0">{{rowData.agencyTcode}}</div>
                </td>
                <td>{{rowData.advertiser}}</td>
                <td>{{rowData.submittedBy}}</td>
                <td style="text-align:right">{{rowData.amount | currency:'USD' }}</td>
                <td>{{rowData.paymentTransType}}</td>
                <td>
                  <div class="cusTable">
                    <div class="cusCell">{{rowData.cmComment}}</div>
                    <div
                      style="cursor:pointer"
                      class="input-group-addon commentsadd_on cusCell"
                      *ngIf="rowData.cmComment">
                      <i
                        pTooltip="CM Comments History"
                        class="fa fa-commenting-o dollar_icon"
                        data-toggle="modal"
                        (click)="GetComments(rowData.refundDetailID)">
                      </i>
                    </div>
                  </div>
                </td>
                <td>
                  <p-select 
                  [options]="action" 
                  [autoWidth]="false" 
                  [style]="{'width':'100%','margin-top':'5px'}" 
                  [(ngModel)]="rowData.selectedaction"
                  placeholder="Choose" 
                  name="actiontxt" 
                  appendTo="body" 
                  optionLabel="actionType">
                    <ng-template pTemplate="selectedItem" let-selectedOption>
                      {{ selectedOption?.actionType }}
                    </ng-template>
                    <ng-template pTemplate="item" let-option>
                      {{ option.actionType }}
                    </ng-template>
                  </p-select>
                  <div *ngIf="!rowData.invalidAction">
                  <span class="input-ErrorField">Action Required</span> 
                  </div>
                </td>
                <td>
                  <textarea
                    required
                    rows="4"
                    cols="50"
                    class="form-control"
                    [(ngModel)]="rowData.comments"
                    name="comments"
                    maxlength="1000">
                  </textarea>
                  <div *ngIf="!rowData.invalidComments">
                    <span class="input-ErrorField">Comments Required</span>
                  </div>
                </td>
                <td>
                  <button 
                    [ngStyle]="{'margin-top':'5px'}" 
                    (click)="submitAction(rowData)" 
                    [disabled]="disableSubmitBtn" 
                    type="button" 
                    class="btn btn-success order_buttonicon">
                    Submit
                  </button>
                </td>
              </tr>
            </ng-template>
          </p-table>
           
        </div>
        <!-- Transaction Tabs ends here -->
      </div>
    </div>
  </div>
  <!-- tab ends here -->
